// 将邮箱转换为匿名标识，避免GA4 PII过滤
function anonymizeEmail(email) {
  if (!email) return ''
  return email.replace(/@/g, '_').replace(/\./g, '_')
}

var GA = {
  track: function(eventName, params) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, params || {})
    }
  },
  pageView: function(pageName) {
    this.track('page_view', { page_name: pageName })
  },
  // 页面展示事件，带用户邮箱
  pageShow: function(pageName) {
    var userEmail = ''
    try {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo && userInfo.email) {
        userEmail = userInfo.email
      }
    } catch (e) {}
    this.track('page_show', {
      page_name: pageName,
      user_email: anonymizeEmail(userEmail)
    })
  },
  homeView: function() {
    this.track('home_view', { page: 'home' })
  },
  loginClick: function() {
    this.track('login_click', { method: 'button' })
  },
  loginSuccess: function(userId, loginMethod) {
    this.track('login_success', {
      user_email: anonymizeEmail(userId),
      login_method: loginMethod
    })
  },
  generateClick: function(modelId, modelName) {
    this.track('generate_click', {
      model_id: modelId,
      model_name: modelName
    })
  },
  modelClick: function(modelId, modelName, source) {
    this.track('model_click', {
      model_id: modelId,
      model_name: modelName,
      source: source || 'sidebar'
    })
  },
  toolClick: function(toolId, toolName, source) {
    this.track('tool_click', {
      tool_id: toolId,
      tool_name: toolName,
      source: source || 'sidebar'
    })
  },
  subscribeClick: function(userId, billingCycle, planName) {
    this.track('subscribe_click', {
      user_email: anonymizeEmail(userId),
      billing_cycle: billingCycle,
      plan_name: planName
    })
  },
  paymentSuccess: function(userId, planName, amount) {
    this.track('payment_success', {
      user_email: anonymizeEmail(userId),
      plan_name: planName,
      amount: amount
    })
  },
  paymentCancel: function(userId) {
    this.track('payment_cancel', {
      user_email: anonymizeEmail(userId)
    })
  }
}

export default GA
